import filter from 'lodash/filter'

import { IWithReferences, Reference } from '@Generated/graphql'

export const getReferencesMatch = <D extends Reference, T extends IWithReferences>(block: T, search?: { key: keyof Reference, value: string }) => {
  if (search) {
    return (filter(block.references, ref => ref[search.key]?.toString() === search.value) || []) as D[]
  }
  return (block.references || []) as D[]
}
